import React from "react";
import image from "../assets/danfoss.svg";
import logo1 from "../assets/userGuideAssets/Picture2.png";
import measuremmentUnit from "../assets/userGuideAssets/measurementUnit.png";
import unitType from "../assets/userGuideAssets/unitType.png";
import grid from "../assets/userGuideAssets/Grid.png";
import filter from "../assets/userGuideAssets/filter.png";
import barchart from "../assets/userGuideAssets/barChart.png";
import TransferButton from "../assets/userGuideAssets/transferbutton.png"
import table from "../assets/userGuideAssets/table.png"
import selected from "../assets/userGuideAssets/selectedmotor.png"
import functionDiagram from "../assets/userGuideAssets/functionDiagram.png"
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Box, Typography } from "@mui/material";
import { jsPDF } from "jspdf";

const Header = () => {
  const handleDownloadPDF = () => {
    const doc = new jsPDF("p", "pt", "a3");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Layout constants
    const headerHeight = 42;
    const marginX = 40;
    const stepColWidth = (pageWidth - marginX * 2) * 0.25; // 25% Steps
    const imageColumnWidth = (pageWidth - marginX * 2) * 0.25; // 25% Component
    const col1X = marginX + stepColWidth + 10;
    const col2X = col1X + imageColumnWidth + 30;
    const col2Width = pageWidth - col2X - marginX; // 50% Description

    const rowGap = 18;
    const bodyFontSize = 8;
    const lineHeight = bodyFontSize * 1.35;
    const bottomLimit = pageHeight - 40;

    const drawHeader = () => {
      doc.setFillColor("#e2000f");
      doc.rect(0, 0, pageWidth, headerHeight, "F");

      // logo
      const logoW = 70,
        logoH = 30;
      const logoX = pageWidth - logoW - 40;
      const logoY = (headerHeight - logoH) / 2;
      doc.addImage(logo1, "PNG", logoX, logoY, logoW, logoH);

      // title
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.setTextColor("#ffffff");
      doc.text(
        "Orbital Motor Pre-selector User Guide",
        marginX,
        headerHeight / 2 + 6
      );
    };

    const drawTableHeader = (yTop) => {
      doc.setFontSize(10);
      doc.setTextColor("#111");
      doc.setFont("helvetica", "bold");
      doc.text("Steps", marginX, yTop);
      doc.text("Component", col1X, yTop);
      doc.text("Description", col2X, yTop);
      doc.setLineWidth(0.5);
      doc.line(marginX, yTop + 5, pageWidth - marginX, yTop + 5);

      // reset font for body rows
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor("#444");
    };

    // ---- Start first page
    drawHeader();
    let y = headerHeight + 40;
    drawTableHeader(y);
    y += 20;

    // Rows with step numbers added
    const rows = [
      {
        step: "1. Unit System",
        img: { src: measuremmentUnit, w: 160, h: 60 },
        text: "Choose between Metric or Imperial units.",
      },
      {
        step: "2. Operating Point Type",
        img: { src: unitType, w: 160, h: 60 },
        text: [
          "Select input type:",
          "  - Torque and speed – for new applications",
          "  - Pressure and flow – for systems with a known pump",
        ],
      },
      {
        step: "3. Max Operating Point",
        img: { src: grid, w: 160, h: 110 },
        text: "Mark the maximum operating point in the Grid.",
      },
      {
        step: "4. Optional Selection Criteria",
        img: { src: filter, w: 160, h: 110 },
        text: [
          "Refine motor selection by specifying the following motor design options:",
          "- Gearwheel set",
          "- Valve system",
          "- Radial bearing load",
        ],
      },
      {
        step: "5. Graph (Switch between graph or table)",
        img: { src: barchart, w: 160, h: 110 },
        text: [
          "Displays:",
          "- Motor series and displacement that meet the specified operating point requirements.",
          "- Displays the top 10 motors ranked by overall efficiency",
        ],
      },
      {
        step: "6. Table",
        img: { src: table, w: 160, h: 110 },
        text: [
          "The Table Displays the Following Information",
          "- Motor series and displacement that meet the specified operating point requirements.",
          "- Required pressure and flow (if input is speed and torque)",
          "- Generated torque and speed (if input is pressure and flow)",
          "- Motor design specifications: Gearwheel set, Valve system, Bearing type, and Radial bearing load capacity.",
          "- Performance indicators: Overall efficiency and TPI index*",
          "The table is sortable by selecting the column headers.",
        ],
      },
      {
        step: "7. Select Motors",
        img: { src: selected, w: 160, h: 110 },
        text: [
          "Choose up to 3 motors from the table for further investigation in the full function diagram.",
        ],
      },
      {
        step: "8. Further Investigation",
        img: { src: functionDiagram, w: 160, h: 110 },
        text: [
          "Analyze motor performance by selecting different operating points in the full function diagram(s).",
          "The following data will be displayed:",
          "- Motor series and displacement selected",
          "- Required pressure and flow needed to generate the selected operating point",
          "- Overall efficiency",
          "- Whether the operating point is within the continuous operation area (True) or the intermittent area (False)",
        ],
      },
      {
        step: "9. Select motors to Quick Selector",
        img: { src: selected, w: 160, h: 110 },
        text: "In the table, select the final motors you want to investigate to determine which options best match your application.",
      },
      {
        step: "10. Transfer to Quick Selector",
        img: { src: TransferButton, w: 160, h: 110 },
        text: "The Quick Selector opens with motors already selected, so you can start reviewing right away.",
      },
    ];

    const ensureSpace = (needed) => {
      if (y + needed > bottomLimit) {
        doc.addPage();
        drawHeader();
        y = headerHeight + 40;
        drawTableHeader(y);
        y += 20;
      }
    };

    rows.forEach((row) => {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor("#444");

      const textArray = Array.isArray(row.text) ? row.text : [row.text];
      const lines = textArray.flatMap((line) =>
        doc.splitTextToSize(line, col2Width)
      );
      const textHeight = lines.length * lineHeight;

      if (row.img) {
        const imgH = row.img.h;
        const rowHeight = Math.max(imgH, textHeight);

        ensureSpace(rowHeight + rowGap);

        // 🔹 Wrap step text inside step column width
        const stepLines = doc.splitTextToSize(row.step, stepColWidth);
        const stepTextHeight = stepLines.length * lineHeight;

        // 🔹 Vertically align the step text with the row
        const stepY = y + (rowHeight - stepTextHeight) / 2 + bodyFontSize;
        doc.text(stepLines, marginX, stepY, {
          lineHeightFactor: lineHeight / bodyFontSize,
        });

        const imageX = col1X;
        const imageY = y;
        doc.setDrawColor(200); // Light gray
        doc.setLineWidth(0.3);
        doc.rect(imageX - 1, imageY - 1, row.img.w + 2, row.img.h + 2); // borde
        doc.addImage(row.img.src, "PNG", col1X, y, row.img.w, row.img.h);

        // 🔹 Description text aligned vertically with image
        const textY = y + (imgH - textHeight) / 2 + bodyFontSize;
        doc.text(lines, col2X, textY, {
          lineHeightFactor: lineHeight / bodyFontSize,
        });

        y += rowHeight + rowGap;
      }
    });

    // Rest of your code (TPI section) unchanged...
    // ---- TPI Section ----
    const neededHeightForTPI = 200; // rough estimate of space needed
    ensureSpace(neededHeightForTPI);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.setTextColor("#111");
    doc.text("Technical Performance Index (TPI)", marginX, y);
    y += 25;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor("#444");

    const tpiText = [
      "*Technical Performance Index (TPI) is a Danfoss-developed indicator used to compare hydraulic orbital motors within the Danfoss portfolio.",
      "It focuses on key internal components such as rotating elements, valve systems, and bearing types that influence motor durability and efficiency.",
      "",
      "The TMTHW motor serves as the reference point (Index = 100) in the Technical Performance Index (TPI), enabling users to quickly compare motor performance in the early stages of selection.",
      "",
      "Disclaimer:",
      "",
      "The Technical Performance Index (TPI) is intended exclusively as a preliminary screening indicator and must not be relied upon as the sole basis for final motor selection.",
      "For accurate selection and validation, users are strongly advised to:",
      "- Align catalogue specifications with the specific requirements of the intended application",
      "- Conduct performance testing under actual operating conditions",
      "- Recognize that TPI is not a substitute for comprehensive engineering analysis or professional consultation",
    ];

    const tpiLines = doc.splitTextToSize(
      tpiText.join("\n"),
      pageWidth - marginX * 2
    );
    doc.text(tpiLines, marginX, y, { lineHeightFactor: 1.5 });

    doc.save("Pre-selector_User_Guide.pdf");
  };
  
  

  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#e2000f",
          height: "72px",
        }}
      >
        <Toolbar
          sx={{
            width: "100%",
            boxSizing: "border-box",
            px: { xs: 2, sm: 3, md: 5 },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "1500px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "100%",
              flexWrap: "wrap",
            }}
          >
            {/* Left Section (Logo) */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                marginTop: { xs: "7px", sm: "15px", md: "15px" },
              }}
            >
              <img
                src={image}
                alt="logo"
                style={{
                  height: "100%",
                  maxHeight: "70px",
                  width: "auto",
                  objectFit: "contain",
                }}
              />
            </Box>

            {/* Right Section (User Guide link) */}
            {/* <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 1,
              }}
            >
              <Typography
                onClick={handleDownloadPDF}
                sx={{
                  color: "#fff",
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontWeight: 500,
                  "&:hover": { opacity: 0.8 },
                }}
              >
                User Guide
              </Typography>
            </Box> */}
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
